import Config from '../config';
import Model from './model';

import { requestify } from '../utils/promisify';
import { parseYYYYMMDD } from '../utils/date';

export default Model.extend( {

    customParser(payload) {
        if ('string' === typeof payload.create_date)
            payload.create_date = parseYYYYMMDD( payload.create_date );
        else if ('number' === typeof payload.time)
            payload.create_date = new Date( payload.create_date * 1000 );

        return payload;
    }

}, {

    delete(taskAttrs, {id, file_type, type, extension}) {
        let suffix;
        switch (file_type || type) {
            case 'FILE': suffix = 'files'; break;
            case 'PHOTO': suffix = 'photos'; break;
            case 'SOUND': suffix = 'sounds'; break;
            case 'VIDEO': suffix = 'flv' === extension ? 'video' : 'difvideo'; break;
        };

        const url = Config.url( `news/${taskAttrs.id}/${suffix}/${id}?apiVersion=1.4` );
        return requestify( $.ajax( {
            url,
            dataType: 'json',
            data: JSON.stringify( { action: 'delete' } ),
            method: 'POST',
            contentType: 'application/json; charset=UTF-8',
        } ) );
    },

} );


// WEBPACK FOOTER //
// ./src/js/model/file.js